import { User } from '@sm-dashboard/reshet-types';

import jwt from 'jwt-decode';

export function getUser(): User | undefined {
  const token = localStorage.getItem('reshet-token');

  if (!token) return;
  const user: User = jwt(token);
  // if the user is a worker in a institution, set the user id to the parent id
  if (user?.parentId && user?.tags && user?.tags.includes('עובד בית חב"ד')) {
    user.currentId = user.id;
    user.id = user.parentId;
  }

  return user;
}
